import React, { useState } from "react";
import styles from "./CreateAutomationRule.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import { FiFileText } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const CreateAutomationRule = () => {
  const dispatch = useDispatch();

  const [ruleName, setRuleName] = useState("");
  const [status, setStatus] = useState("");
  const [whenField, setWhenField] = useState("");
  const [isCondition, setIsCondition] = useState("");
  const [value, setValue] = useState("");

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setRuleName("");
    setStatus("");
    setWhenField("");
    setIsCondition("");
    setValue("");
  };

  const handleSave = () => {
    const payload = {
      ruleName,
      status,
      whenField,
      isCondition,
      value,
    };
    console.log("Saved Rule:", payload);
    dispatch(closeModal());
  };

  return (
    <div className={styles.container}>
      <div  className={styles.sectionBox}>
      {/* Header */}
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<FiFileText />}
          heading="Create Automation rule"
        />
        <ToClose onClose={handleClose} />
      </div>

      {/* Card Body */}
      <div className={styles.card}>
        <HeadingAndData
          label="Rule Name"
          name="ruleName"
          placeholder="Enter template name"
          value={ruleName}
          onChange={(e) => setRuleName(e.target.value)}
          required
        />

        <p className={styles.sectionLabel}>SET A TRIGGER</p>

        <HeadingAndDropDown
          label="Set enquiry status"
          name="status"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          options={[
            { label: "New", value: "new" },
            { label: "In Progress", value: "progress" },
            { label: "Closed", value: "closed" },
          ]}
          placeholder="Select status"
        />

        <p className={styles.sectionLabel}>AND</p>

        <div className={styles.conditionRow}>
          <HeadingAndDropDown
            name="when"
            value={whenField}
            onChange={(e) => setWhenField(e.target.value)}
            options={[
              { label: "Amount", value: "amount" },
              { label: "Date", value: "date" },
            ]}
            placeholder="Select"
          />
          <span className={styles.isText}>is</span>
          <HeadingAndDropDown
            name="isCondition"
            value={isCondition}
            onChange={(e) => setIsCondition(e.target.value)}
            options={[
              { label: "Greater than", value: "gt" },
              { label: "Less than", value: "lt" },
            ]}
            placeholder="Select"
          />
        </div>

        <HeadingAndData
          label="Value"
          name="value"
          placeholder="Set value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />

        <div className={styles.footerActions}>
          <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
        </div>
      </div>
      </div>
    </div>
  );
};

export default CreateAutomationRule;
